var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w-full flex", class: _vm.isMobile ? `h-full` : `h-96` },
    [
      _c("div", { staticClass: "m-auto text-gray-400" }, [
        _vm._v(" " + _vm._s(_vm.message) + " "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }